<div class="ui-g-12 pl-0 mb-2">
  <div class="deferred-service-wrapper">
    <div class="deferred-service-inner-container d-flex">
      <!-- Deferred service head -->
      <div class="deferred-stripe-head flex-column">
        <p class="m-0 font-14 font-bold font-secondary-900 text-truncate">Deferred services</p>

        <p class="m-0">
          <a href="javascript:;" class="text-primary gray-scale-btn font-14 font-600" (click)="handleViewAllClick()">
            View all
          </a>
        </p>
      </div>

      <!-- Deferred service body -->
      <div class="deferred-stripe-body flex-start-center">
        <div class="deferred-service-loader font-16 flex-center-center" [hidden]="!isLoading">
          <span class="pr-2 pl-5">Loading</span> <i class="fal fa-spinner rotate"></i>
        </div>

        <div class="deferred-service-box flex-center-center"
          *ngFor="let service of visibleDeferredServices || [] | slice: 0 : 3; let serviceIndex = index"
          [hidden]="isLoading">
          <div class="deferred-service-box-deferred flex-column"
            tooltipStyleClass="ticket-tooltip ticket-tooltip modifier deferred-services-size" tooltipPosition="top"
            [pTooltip]="service?.tooltip" [escape]="false">
            <div class="deferred-service-content flex-between-center">
              <h5 class="deferred-service-title mb-0 font-14 font-600 font-gray-55 text-truncate">
                {{service?.title}}
              </h5>

              <div class="deferred-strip-action flex-end-center pl-2">
                <span>({{service?.serviceTotal?.total || 0 | currency: usd }})</span>
                <i class="fas fa-times-circle pl-1 font-gray-55 pointer"
                  (click)="handleConfirmServiceDelete(service)"></i>
              </div>
            </div>

            <div class="deferred-service-content flex-between-center">
              <span class="font-12 pointer font-gray-55 hover-underline"
                (click)="openOrder(service?.estimate?.estimateId)">
                RO#{{service?.estimate?.estimateCode}}
              </span>

              <a href="javascript:;" class="font-primary font-600 font-14" (click)="handleAddServiceClick(service)">
                Add
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- Deferred service tail -->
      <div class="deferred-stripe-tail flex-between-center">
        <div class="flex-column" [ngClass]="{'invisible': !hiddenServicesCount}">
          <p class="m-0 font-14 font-600 font-gray-35">
            {{hiddenServicesCount > 1? '+': ''}}&nbsp;{{hiddenServicesCount}}&nbsp;more
          </p>
        </div>

        <div class="flex-end-center pointer" (click)="handleHideServiceStripeClick();">
          <i class="far font-18 ml-2 fa-eye-slash font-gray-35"></i>
        </div>
      </div>
    </div>
  </div>
</div>
